module.exports = __webpack_public_path__ + "img/shandui.aeaf33d0.png";